export const STORAGE_KEYS = {
  GALLERY: "galleryData",
  LANGUAGES: "languagesData",
  VOICE: "voiceData",
  SELECTED_LANGUAGE: "selectedLanguage",
  VISITED_PINS: "visitedPins",
  GALLERY_IMAGES: "galleryImages",
  VOICE_FILES: "voiceFiles",
  IMAGES: "images",
  PAYMENT_UUID: "payment_uuid",
};
